var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "share_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#share_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M12 14.665a1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 10 12.665c0-.077.006-.158.017-.241.01-.084.027-.159.05-.225l-4.7-2.734c-.19.167-.4.298-.634.392A1.936 1.936 0 0 1 4 9.999a1.929 1.929 0 0 1-1.417-.584A1.929 1.929 0 0 1 2 8c0-.556.194-1.028.583-1.417A1.929 1.929 0 0 1 4 5.999c.256 0 .5.047.733.141.234.095.445.225.634.392l4.7-2.733a1.218 1.218 0 0 1-.05-.225A1.831 1.831 0 0 1 10 3.332c0-.556.194-1.028.583-1.417A1.929 1.929 0 0 1 12 1.332c.556 0 1.028.194 1.417.583.389.39.583.861.583 1.417s-.194 1.028-.583 1.417A1.929 1.929 0 0 1 12 5.332c-.256 0-.5-.047-.733-.142a2.195 2.195 0 0 1-.634-.391l-4.7 2.733c.023.067.04.142.05.225a1.83 1.83 0 0 1 0 .483 1.224 1.224 0 0 1-.05.225l4.7 2.734c.19-.167.4-.297.634-.392.233-.094.477-.142.733-.142.556 0 1.028.195 1.417.584.389.389.583.86.583 1.416 0 .556-.194 1.028-.583 1.417a1.929 1.929 0 0 1-1.417.583Z"
}))));
export default SvgShare;